import React from 'react';
import Form from 'gatsby-core-theme/src/components/molecules/newsletter/form'

export default function index(props) {
  return (
    <Form {...props} showLabels={false} submitText='Subscribe'/>
  )
}
